(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mainview-down"] && !Shopify.designMode) return;
  try {
    
$('.mainview-down').slick({
dots: false,
infinite: true,
arrows: false,
speed: 300,
autoplay: true,
autoplaySpeed: 2500,
rtl: true,
slidesToShow: 5,
slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainview-up"] && !Shopify.designMode) return;
  try {
    
$('.mainview-up').slick({
dots: false,
infinite: true,
arrows: false,
speed: 300,
autoplay: true,
autoplaySpeed: 2500,
slidesToShow: 5 ,
slidesToScroll: 1,
responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
$('.item-img').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});
// 変数に要素を入れる
var trigger = $('.modal__trigger'),
    wrapper = $('.modal__wrapper'),
    container = $('.modal__container'),
    close = $('.modal__close');

// 『モーダルを開くボタン』をクリックしたら、『モーダル本体』を表示
$(trigger).click(function() {
  var index = $(this).index();
  $(wrapper).css('display', 'none').removeClass("open");
  $(wrapper).eq(index).css('display', 'block').addClass("open");

  // スクロール位置を戻す
  $(container).scrollTop(0);

  // サイトのスクロールを禁止にする
  $('html, body').addClass("open");
});

// 『背景』と『モーダルを閉じるボタン』をクリックしたら、『モーダル本体』を非表示
$(wrapper).add(close).click(function() {
  $(wrapper).css('display', 'none').removeClass("open");                   
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranking"] && !Shopify.designMode) return;
  try {
    

$('.slick-ranking').slick({
infinite: false,
dots: true,
arrows: false,
slidesToShow: 5,
slidesToScroll: 1,
autoplay: true,
responsive: [{
                breakpoint: 640,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
              }
              ]
});

  } catch(e) { console.error(e); }
})();
})();
